import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, FormControl, Select, MenuItem, TextField, Typography, Button } from "@mui/material";

export default function CopyScheduleDialog({ open, onClose, copyChoice, setCopyChoice, customCopyDate, setCustomCopyDate, onCopy }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Copy Previous Week's Schedule</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <Select
            value={copyChoice}
            onChange={e => setCopyChoice(e.target.value)}
          >
            <MenuItem value="last">Last week</MenuItem>
            <MenuItem value="twoweeks">2 weeks ago</MenuItem>
            <MenuItem value="custom">Custom week...</MenuItem>
          </Select>
        </FormControl>
        {copyChoice === "custom" && (
          <TextField
            type="date"
            label="Custom Week Start (Monday)"
            value={customCopyDate.toISOString().substr(0, 10)}
            onChange={e => setCustomCopyDate(new Date(e.target.value))}
            sx={{ mt: 2 }}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        )}
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          This will copy all shifts from the selected week into the current week, replacing any existing shifts.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onCopy} variant="contained">
          Copy
        </Button>
      </DialogActions>
    </Dialog>
  );
}
